import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { CONTACT } from '@/data/content';

const REGISTRATION_TEMPLATE = [
  'NEW ASA REGISTRATION',
  'Player name: ',
  'Parent/Guardian: ',
  'Phone: ',
  'Age: ',
  'Program: ',
].join('\n');

const waBase = CONTACT.whatsapp.split('?')[0];

export default function WhatsAppFab() {
  return (
    <motion.a
      href={`${waBase}?text=${encodeURIComponent(REGISTRATION_TEMPLATE)}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Complete your registration on WhatsApp"
      data-testid="whatsapp-fab"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.5 }}
      whileHover={{ scale: 1.08 }}
      className="fixed bottom-5 right-5 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_8px_32px_rgba(37,211,102,0.45)]"
    >
      <MessageCircle size={28} className="text-night" fill="currentColor" strokeWidth={0} />
      <span className="absolute inset-0 rounded-full border-2 border-[#25D366]/60 animate-ping [animation-duration:2.5s]" aria-hidden="true" />
    </motion.a>
  );
}
